const mConfirmForgotPassword = {
  mConfirmForgotPassword: {
    alerts: {
      error: 'Los datos ingresados son incorrectos.',
      success: 'La contraseña nueva se guardo de forma exitosa.'
    },

    buttonPrimary: 'ACCEDER',

    descripcion: 'A continuación introduce la nueva contraseña de tu cuenta que pertenece al e-mail ',

    formInfo: 'Nueva Contraseña',

    inputs: {
      confirm_password: {
        placeholder: 'Confirmar contraseña'
      },

      new_password: {
        placeholder: 'Nueva contraseña'
      }
    },

    validation: {
      confirm_password: {
        required: 'Confirmar contraseña es requerido.',
        sameAsPassword: 'La contraseña no coinciden.'
      },

      new_password: {
        minLength: 'La longitud mínima permitida es de 8 caracteres.',
        required: 'Nueva contraseña es requerida.',
        valid: 'La contraseña debe contener minúsculas, mayúsculas y números.'
      }
    }
  }
}

export default mConfirmForgotPassword
